import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

export function initSentry() {
  if (!SENTRY_DSN) {
    console.log('Sentry DSN not configured, skipping initialization')
    return
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session replay disabled to stay within free tier limits
      // Sentry.replayIntegration({
      //   maskAllText: false,
      //   blockAllMedia: false,
      // }),
    ],
    // Performance monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session replay disabled
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Tag to identify this component
    initialScope: {
      tags: {
        component: 'web',
      },
    },
  })
}

export function setUserContext(userId: string) {
  Sentry.setUser({ id: userId })
}

export function clearUserContext() {
  Sentry.setUser(null)
}

export function setSessionContext(sessionId: string) {
  Sentry.setTag('session_id', sessionId)
}

export function captureException(error: unknown, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context })
}

export { Sentry }
